import React from 'react'
import PropTypes from 'prop-types'
import { Form, Modal, Tabs } from 'antd'
import { ACTION } from '../../../../utils/constants'
import InfoForm from './InfoForm'
import ConditionForm from './ConditionForm'

const { TabPane } = Tabs

const BrandActivityForm = (props) => {
  const { visible, onOk, onCancel, form, action, formState } = props

  return (
    <Modal
      width={1000}
      title={`${action} a Brand Activity`}
      visible={visible}
      closable={false}
      footer={null}>
      {action === ACTION.CREATE ? (
        <InfoForm action={action} onCancel={onCancel} onOk={onOk} />
      ) : (
        <Tabs defaultActiveKey="1">
          <TabPane tab="Brand Activity Info" key="1">
            <InfoForm
              action={action}
              onCancel={onCancel}
              form={form}
              formState={formState}
              onOk={onOk}
            />
          </TabPane>
          <TabPane tab="Brand Activity Condition" key="2">
            <ConditionForm
              action={action}
              onCancel={onCancel}
              form={form}
              formState={formState}
              onOk={onOk}
            />
          </TabPane>
        </Tabs>
      )}
    </Modal>
  )
}

BrandActivityForm.propTypes = {
  visible: PropTypes.bool.isRequired,
  action: PropTypes.string.isRequired,
  formState: PropTypes.any.isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}

const WrappedBrandActivityForm = Form.create({
  name: 'BrandActivityForm'
})(BrandActivityForm)
export default WrappedBrandActivityForm



// WEBPACK FOOTER //
// ./src/pages/Brand/BrandActivity/BrandActivityForm/index.js